import * as React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../../components/Button';
import styled from '../../../styled-components';
import { ApplicationState } from '../../../types/api';
import { Candidate } from '../types';

const FormInput = styled.input`
    width: 20em;
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`;

interface EditCandidateFormProps {
    candidate: Candidate;
    onUpdate: (candidate: Candidate) => void;
    onInvite: (candidate: Candidate) => void;
    onRemove: (candidate: Candidate) => void;
}

interface EditCandidateFormState {
    showInvitationSentNotification: boolean;
}

const Layout = styled.div`
    input,
    ${Button} {
        margin-bottom: 0.5em;
    }
`;

class EditCandidateForm extends React.Component<EditCandidateFormProps, EditCandidateFormState> {
    constructor(props: EditCandidateFormProps) {
        super(props);

        this.onCandidateAttributeChange = this.onCandidateAttributeChange.bind(this);
        this.handleOnRemove = this.handleOnRemove.bind(this);
        this.handleOnInvite = this.handleOnInvite.bind(this);
    }

    private onCandidateAttributeChange(event) {
        const attributeName = event.target.name;
        const attributeValue = event.target.value;
        if (attributeValue && attributeValue.length && this.props.candidate[attributeName] !== attributeValue) {
            const candidateToUpdate: Candidate = Object.assign({}, this.props.candidate, {
                [attributeName]: attributeValue
            });
            this.props.onUpdate(candidateToUpdate);
        }
    }

    private handleOnRemove() {
        this.props.onRemove(this.props.candidate);
    }

    private handleOnInvite() {
        this.props.onInvite(this.props.candidate);
    }

    public render() {
        const candidate = this.props.candidate;
        return (
            <Layout>
                <FormInput
                    name="firstname"
                    placeholder="Firstname"
                    defaultValue={candidate.firstname}
                    onBlur={this.onCandidateAttributeChange}
                />
                <FormInput
                    name="lastname"
                    placeholder="Lastname"
                    defaultValue={candidate.lastname}
                    onBlur={this.onCandidateAttributeChange}
                />
                <FormInput
                    name="email"
                    placeholder="E-Mail"
                    defaultValue={candidate.email}
                    onBlur={this.onCandidateAttributeChange}
                />
                <ButtonWrapper>
                    <Button normal onClick={this.handleOnInvite}>
                        Invite {candidate.applicationState === ApplicationState.CREATED ? 'candidate' : 'again'}
                    </Button>
                    <Button normal onClick={this.handleOnRemove}>
                        Remove candidate
                    </Button>
                </ButtonWrapper>
                <Link to={`/candidate/${candidate.id}`}>Candidate Page</Link>
            </Layout>
        );
    }
}

export default EditCandidateForm;



// WEBPACK FOOTER //
// ./src/scenes/administrator/components/EditCandidateForm.tsx